import { useRouter } from '@abyss/web/hooks/useRouter';
import { useBreadcrumbStore } from '@src/store/common/BreadcrumbStore';
import { BreadcrumbItem } from './BreadcrumbTypes';

const BreadcrumbService = () => {
  const { getRouteParams } = useRouter();
  const params = getRouteParams('');
  const setBreadcrumb = useBreadcrumbStore((state) => state.setBreadcrumb);

  const UpdateBreadcrumb = async (data: Array<BreadcrumbItem>) => {
    let items = structuredClone(data);
    items.map((element) => {
      if (element.href?.includes(':') && params !== null) {
        Object.entries(params).forEach(([key, val]) => {
          const stringToReplace = `:${key}`;
          const valueReplaceBy = val as string;
          if (element?.href?.includes(stringToReplace)) {
            element.href = element.href.replace(
              stringToReplace,
              valueReplaceBy
            );
          }
        });
      }
      let title = element.title;
      if (element.prefix) {
        title = `${element.prefix} ${title}`;
      }
      if (element.suffix) {
        title = `${title} ${element.suffix}`;
      }
      if (element.prefixedAddEditLabel && params.id) {
        title =
          (~~params.id > 0
            ? element.prefixedAddEditLabel.Edit
            : element.prefixedAddEditLabel.Add) +
          ' ' +
          title;
      }
      element.title = title;
    });
    await setBreadcrumb(items);
  };

  return { UpdateBreadcrumb };
};

export { BreadcrumbService };
